module.exports = new __parcel__URL__("new_logo.d9372fce.png").toString();